"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RetailOfferState = /** @class */ (function () {
    function RetailOfferState() {
    }
    return RetailOfferState;
}());
exports.default = RetailOfferState;
//# sourceMappingURL=RetailOfferState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/RetailerOffer/RetailOfferState.js
// module id = 2250
// module chunks = 8